export default __webpack_public_path__ + "static/media/Paint Mixer (2).b3e8e977.jpg";